import { accountService } from "../_services/accounts.service";

/** Sent on API calls so the backend can pick the correct tenant when Host is the API (e.g. dcss-api.azurewebsites.net). */
export function tenantHeaders(): Record<string, string> {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return {};
  }
  return { "X-Tenant-Host": window.location.hostname };
}

export function authHeader(): any {
  // return authorization header with jwt token
  const currentUser = accountService.currentUserValue;

  //return { Authorization: `Bearer ${currentUser.token}` };
  if (currentUser && currentUser.token) {
    return { Authorization: `Bearer ${currentUser.token}` };
  }

  return {};
}

export function getHeader() {
  let header = { ...authHeader(), ...tenantHeaders() };
  header["Content-Type"] = 'application/json';

  return header;
}

export function getUploadHeader() {
  let header = { ...authHeader(), ...tenantHeaders() };
  header['content-type'] = 'multipart/form-data';
  return header;
}


